var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Mall.PayOrder",
    "options": {
        "objc_class_prefix": "MallPayOrder",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "purpose",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "productId",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "channel",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "tradeType",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "tuid",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "returnUrl",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "clientType",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "platform",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "rewardType",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "rewardConfigId",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ext",
                    "id": 11
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "OrderInfo",
                    "name": "orderInfo",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "wxpay",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "iap",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "alipay",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "iab",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "h5",
                    "id": 6
                }
            ]
        },
        {
            "name": "OrderInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "orderId",
                    "id": 1
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/recharge/pb/orderpb.js